<script>
import * as ServerTime from '../../../utils/services/pregao-server-time'
import _base from '../../_default/components/_base.vue'
import {merge as _merge} from 'lodash'
// import { Status as SocketStatus } from '../../../domain/leiloes/helpers/SocketStatus'
import * as Status from '../../../domain/leiloes/helpers/LoteStatus'
// import {number_format as numberFormat} from '../../../utils/helpers/phpjs'
import Service from '../../../domain/leiloes/services/pregao'
import Comunicator from 'rogeriomenezes-comunicator'
import moment from 'moment'
import Relogio from './components/Relogio'

export default {
  name: 'PregaoLeiloeiro',
  extends: _base,
  data () {
    return {
      numeroLote: null,
      manual: false,
      animFotos: [],
      animFotosIndex: 0,
      isComConnected: 0,
      stats: {
        previsaoVendas: 0,
        retirados: null,
        condicionais: null,
        naoVendidos: null,
        totalVendas: null,
        valoresCondicionais: null,
        vendidos: null,
        saldoSucata: null,
        vendidosNaoSucata: null,
        arrematantesOnline: 0,
        espectadoresOnline: 0,
        comitentesOnline: 0,
        mediaFipe: {
          valorFipe: null,
          valorVenda: null
        },
        mediaFipeAnterior: null,
        grupo: null,
        comitente: null,
        proximoLote: null
      },
      leilao: {},
      pregao: null,
      lote: {
        numero: 0,
        imagem: null,
        descricao: '-',
        valorInicial: 0.00,
        valorIncremento: 0.00,
        valorMinimo: 0.00,
        valorMeta: 0.00,
        lancePrincipal: null,
        status: null,
        comitente: {
          pessoa: {}
        },
        pregao: null,
        lances: []
      },
      isLoading: false,
      centerContentFolded: false,
      hasNovoLance: false,
      countDownTimer: 10,
      defaultDownTimer: 10
    }
  },
  created () {
    this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
    Service.telaAuxilio(this.$route.params.id)
      .then((response) => {
        this.$loaderOverlay.hide()
        this.isLoading = false
        this.leilao = response.data.leilao
        /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
         this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
         } */
        this.lote = response.data.lote
        this.pregao = response.data.pregao
        if (response.data.previsaoVendas) {
          this.stats.previsaoVendas = response.data.previsaoVendas
        }
        if (this.pregao !== null) {
          window.setTimeout(() => {
            this.centerContentFolded = true
            this.carregaPregao()
          }, 500)
        }
      })
      .catch((response) => {
        this.$loaderOverlay.hide()
        // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
        window.responseError(response)
        console.log(response)
      })

    /* window.setTimeout(() => {
      this.$refs.loteImagem.style.height = ''
      this.$refs.loteImagem.style.height = '100%'
    }, 3000) */
  },
  computed: {
    proximoLote () {
      /* if (!this.$tmpLoteNumero) {
        this.$tmpLoteNumero = 0
      }
      let proximoLote = Number(this.lote.numero) + 1
      if (this.$tmpLoteNumero < proximoLote) {
        this.$tmpLoteNumero = proximoLote
      }
      return this.$tmpLoteNumero */
      if (!this.stats.proximoLote) {
        return null
      }
      return this.stats.proximoLote
    },
    filteredLances: function () {
      let data = this.lote.lances
      if (!Array.isArray(data)) {
        data = []
      }
      // Ordena pelo valor de forma decrescente
      data = data.slice().sort(function (a, b) {
        a = Number(a['valor'])
        b = Number(b['valor'])
        return (a === b ? 0 : a > b ? 1 : -1) * -1 // -1 = desc, 1 = asc
      })

      return data.slice(0, 5) // Somente os 5 últimos lances
    },
    tituloLote () {
      if (this.lote.tituloPregoeiro) {
        return this.lote.tituloPregoeiro.toUpperCase()
      } else if (this.lote.titulo) {
        return this.lote.titulo.toUpperCase()
      }
      return ''
    },
    descricaoLote () {
      if (this.lote.descricaoPregoeiro) {
        return this.lote.descricaoPregoeiro.toUpperCase()
      } else if (this.lote.descricao) {
        return this.lote.descricao.toUpperCase()
      }
      return ''
    },
    observacaoLote () {
      if (this.lote.observacaoPregoeiro) {
        return this.lote.observacaoPregoeiro.toUpperCase()
      } else if (this.lote.observacao) {
        return ''
        // return this.lote.observacao.toUpperCase()
      }
      return ''
    },
    totalLotes () {
      if (typeof this.pregao === 'undefined' || this.pregao === null) {
        return 0
      }
      return this.pregao.totalLotes
    },
    totalSaldo () {
      if (typeof this.pregao === 'undefined' || this.pregao === null) {
        return 0
      }
      return Number(this.pregao.totalLotes) - (Number(this.stats.retirados) + Number(this.stats.vendidos) + Number(this.stats.naoVendidos) + Number(this.stats.condicionais))
    },
    totalSaldoSucata () {
      if (typeof this.pregao === 'undefined' || this.pregao === null) {
        return 0
      }
      return Number(this.stats.saldoSucata)
    },
    percentualVenda () {
      if (!Number(this.stats.mediaFipe.valorVenda) && !Number(this.stats.mediaFipe.valorFipe)) return 0
      return this.round((Number(this.stats.mediaFipe.valorVenda) * 100) / Number(this.stats.mediaFipe.valorFipe), 2)
    },
    percentualVendaAnterior () {
      if (!Number(this.stats.mediaFipeAnterior.valorVenda) && !Number(this.stats.mediaFipeAnterior.valorFipe)) return 0
      return this.round((Number(this.stats.mediaFipeAnterior.valorVenda) * 100) / Number(this.stats.mediaFipeAnterior.valorFipe), 2)
    },
    comitenteNome () {
      if (this.lote.comitente === null) {
        return
      }
      if (typeof this.lote.comitente.pessoa['nome'] === 'undefined') {
        return
      }
      return this.lote.comitente.pessoa.nome.toUpperCase()
    },
    lanceLocalidade: function () {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.pessoa.essencial.cidade + ' - ' + this.filteredLances[0].arrematante.pessoa.essencial.uf : '-'
    },
    lanceData: function () {
      return this.testHasProperty() ? moment(this.filteredLances[0].data.date).format('L') + ' - ' + moment(this.filteredLances[0].data.date).format('LTS') : '-'
    },
    valor: function () {
      return this.testHasProperty() ? this.filteredLances[0].valor : 0
    },
    apelido: function () {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.apelido : '-'
    },
    compras: function () {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.compras : null
    },
    ultimaCompra: function () {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.ultimaCompra : null
    },
    primeiraCompra: function () {
      if (this.apelido === '-') {
        return false
      }
      if (!this.compras) {
        return true
      }
      if (!this.ultimaCompra && Number(this.compras) > 1) {
        return false
      }
      let hoje = moment(new Date()).format('DD/MM/YYYY')
      let ultimaCompra = moment(this.ultimaCompra.date).format('DD/MM/YYYY')
      return hoje === ultimaCompra && Number(this.compras) <= 1
    },
    timerPregao: function () {
      if (typeof this.leilao['timerPregao'] === 'undefined') {
        return 10
      }
      return parseInt(+this.leilao.timerPregao)
    },
    timerPregaoFormatado: function () {
      let timer = Number(this.countDownTimer)
      if (timer < 60) {
        return '00:' + ('0' + timer).slice(-2)
      }
      let hora = Math.floor(timer / 60)
      let minutos = timer % 60
      return ('0' + hora).slice(-2) + ':' + ('0' + minutos).slice(-2)
    },
    Status: function () {
      return Status
    },
    statusLote: function () {
      if (this.lote.status === null) {
        return '-'
      }
      if (typeof this.Status.Status[this.lote.status] !== 'undefined') {
        return this.Status.Status[this.lote.status].titulo
      }
      return 'Status inválido'
    },
    colorStatus () {
      if (this.lote.status === null) {
        return '#FFFFFF'
      }
      if (typeof this.Status.Status[this.lote.status]['color'] !== 'undefined') {
        return this.Status.Status[this.lote.status]['color']
      }
      return '#FFFFFF'
    },
    porcentagemAvaliacao () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let avaliacao = typeof this.lote.valorAvaliacao !== 'undefined' ? this.lote.valorAvaliacao : 0
      if (tabelaFipe > 0 && avaliacao > 0) {
        return this.round((avaliacao / tabelaFipe) * 100, 2)
      }
      return 0
    },
    porcentagemMinimo () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let minimo = typeof this.lote.valorMinimo !== 'undefined' ? this.lote.valorMinimo : 0
      if (tabelaFipe > 0 && minimo > 0) {
        return this.round((minimo / tabelaFipe) * 100, 2)
      }
      return 0
    },
    minimoStyle () {
      return {
        'minimo-superado': Number(this.valor) >= Number(this.lote.valorMinimo)
      }
    },
    fipeLance () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let lance = Number(this.valor)
      if (tabelaFipe > 0 && lance > 0) {
        return this.round((lance / tabelaFipe) * 100, 2) + '%'
      }
      return '0%'
    },
    classLanceOnline () {
      if (typeof this.lote.lancePrincipal !== 'undefined' && this.lote.lancePrincipal !== null && this.lote.lancePrincipal !== 'null') {
        if (this.lote.lancePrincipal.arrematante.apelido !== 'PLATEIA') {
          return ['dash-pregao-online-leiloeiro']
        }
        return ['']
      }
      return ['']
    }
  },
  mounted () {
    /* Realtime Comunicator */
    // this.wsChannel = 'pregao/' + this.$route.params.id
    this.comunicator = Comunicator.connect(process.env.WS_URL)
    this.comunicator.on('lance', this.onLance)
    this.comunicator.on('status', this.onStatus)
    this.comunicator.on('statusLeilao', this.onStatusLeilao)
    this.comunicator.on('tempo', this.onTempo)
    this.comunicator.on('mudaLote', this.onMudaLote)
    this.comunicator.on('lanceDeletado', this.onLanceDeletado)
    this.comunicator.on('alteracaoIncremento', this.onAlteracaoIncremento)
    this.comunicator.on('alteracaoTempo', this.onAlteracaoTempo)
    this.comunicator.on('comitenteDecisaoStatusLote', this.onComitenteDecisaoStatusLote)
    this.comunicator.on('com/connect', (env) => {
      this.isComConnected = 1
    })
    this.comunicator.on('com/disconnect', (env) => {
      this.isComConnected = 2
    })
    window.setTimeout(() => {
      if (this.isComConnected !== 1) {
        this.isComConnected = 2 // No connection alert
      }
    }, 4000)
    /* End */

    this._showMenu(false)
    this._showHeader(true)
    this._showFooter(false)
    this._menuFolded(false)
    this.$nextTick(() => {
      this.$root.$el.classList.add('full-height')
    })
  },
  destroyed () {
    console.log('Saindo da tela realtime')
    this.comunicator.close()
    this.$root.$el.classList.remove('full-height')
  },
  methods: {
    onLance: function (data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return
      }
      this.lote.lances.unshift(data.lote.lance)
      this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null
      this.remoteNovoLance({
        id: data.lote.id,
        status: data.lote.status,
        lancePrincipal: data.lote.lance
      }, data.lote.lance)
    },
    onStatus: function (data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return
      }
      delete this.lote.pregao
      _merge(this.lote, data.lote)
      this.mountTimerCountdown()
    },
    onStatusLeilao: function (data) {
      if (!this.validateComunication(data)) {
        return
      }
      if (data.status === 6) {
        // Carrega o pregão
        this.carregaPregao()
      }
      this.leilao.status = data.status
    },
    onTempo: function (data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return
      }
      console.log('TEMPO!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', data)
      this.lote.pregao.dataAbertura.date = data.lote.tempo.date
      if (this.filteredLances.length > 0) {
        this.lote.lances[0].data = {date: data.lote.tempo}
      }
      this.$nextTick(() => {
        this.mountTimerCountdown()
      })
    },
    onMudaLote: function (data) {
      if (!this.validateComunication(data) || this.manual) {
        return
      }
      this.carregaPregao()
      /* this.leilao = data.leilao
      this.pregao = data.pregao
      this.lote = data.lote
      this.$nextTick(() => {
        if (typeof this.leilao['timerPregao'] !== 'undefined') {
          this.updateDefaultTimerPregao(this.leilao['timerPregao'])
          this.mountTimerCountdown()
          this.getStatsLeilao()
        }
      }) */
    },
    onLanceDeletado: function (data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return
      }
      if (this.lote.lances.length === 0) {
        return
      }
      for (let i = 0, len = this.lote.lances.length; i < len; ++i) {
        if (this.lote.lances[i].id === data.lote.lance) {
          this.lote.lances.splice(i, 1)
          break
        }
      }
      this.$nextTick(() => {
        this.updateLancePrincipal()
      })
    },
    onAlteracaoIncremento: function (data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return
      }
      this.lote.valorIncremento = data.lote.incremento
    },
    onAlteracaoTempo: function (data) {
      if (!this.validateComunication(data)) {
        return
      }
      this.leilao.timerPregao = data.tempo
      let that = this
      this.$nextTick(function () {
        that.updateDefaultTimerPregao(that.leilao['timerPregao'])
        that.mountTimerCountdown()
      })
    },
    onComitenteDecisaoStatusLote: function (data) {
      console.log(data) // TODO: Fazer notificação
    },
    validateComunication: function (event) {
      if (typeof event['leilao'] === 'undefined') {
        return false
      }
      if (typeof event['leilao']['id'] !== 'undefined') {
        return event['leilao']['id'] === this.leilao.id
      }
      return event['leilao'] === this.leilao.id
    },
    validateComunicationLote: function (event) {
      if (typeof event['lote'] === 'undefined') {
        return false
      }
      if (typeof event.lote['id'] === 'undefined') {
        if (event.lote === this.lote.id) {
          return true
        }
      } else {
        if (event.lote.id === this.lote.id) {
          return true
        }
      }
      return false
    },
    round: function (number, precision) {
      let factor = Math.pow(10, precision)
      let tempNumber = number * factor
      let roundedTempNumber = Math.round(tempNumber)
      return roundedTempNumber / factor
    },
    testHasProperty: function () {
      return this.filteredLances.length > 0
    },
    toggleKeyboard (v) {
      this.centerContentFolded = v
    },
    reajustaTimerPregao: function (newTimer) {
      this.leilao.timerPregao = this.countDownTimer = newTimer
      this.$nextTick(() => {
        this.mountTimerCountdown()
      })
      console.log('Reajustando timer do pregão')
    },
    carregaPregao: function () {
      let that = this
      if (this.numeroLote) {
        this.manual = true
      }
      Service.telaAuxilio(this.$route.params.id, this.numeroLote)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.isLoading = false
          this.leilao = response.data.leilao
          /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
           this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
           } */
          this.lote = response.data.lote
          this.pregao = response.data.pregao
          if (response.data.previsaoVendas) {
            this.stats.previsaoVendas = response.data.previsaoVendas
          }
          this.fcnTrocaFotos(response.data.lote.imagem, response.data.lote.fotos)
          if (this.pregao !== null) {
            window.setTimeout(() => {
              this.centerContentFolded = true
              that.$nextTick(function () {
                if (typeof that.leilao['timerPregao'] !== 'undefined') {
                  that.updateDefaultTimerPregao(that.leilao['timerPregao'])
                  that.mountTimerCountdown()
                }
              })
            }, 500)
          }
          this.getStatsLeilao()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
          window.responseError(response)
          console.log(response)
        })
    },
    getStatsLeilao () {
      /* window.setTimeout(() => {
        Service.getStatsPregao(this.leilao.id)
          .then((response) => {
            console.log(response.data)
            this.stats = response.data
          })
          .catch((error) => {
            console.log(error)
          }, 2000)
      }) */
    },
    reset: function () {
      this.countDownTimer = this.defaultDownTimer
    },
    updateDefaultTimerPregao: function (seconds) {
      this.defaultDownTimer = parseInt(seconds)
      this.countDownTimer = parseInt(seconds)
    },
    mountTimerCountdown: function () {
      let that = this
      this.$nextTick(function () {
        console.log('Countdown execute...')
        if (typeof this.$intervalCronometro !== 'undefined') {
          window.clearInterval(that.$intervalCronometro)
          that.reset()
        }
        if (typeof this.lote.pregao === 'undefined') {
          console.log('Lote não está em pregão, por isso não inicia o cronômetro.')
          return
        }
        if (this.lote.pregao !== null) {
          console.log('Inicia os ajustes do cronômetro.', this.lote.pregao)
          // Pregão está ativo e cronômetro deve funcionar
          let dataInicio = new Date(String(this.lote.pregao.dataAbertura.date).replace(/ /g, 'T'))

          // Se existe lance, pega a data do último lance, caso tenha sido efetuado depois do pregão ser ativo
          if (this.lote.lances.length > 0) {
            let dataUltimoLance = new Date(this.lote.lances[0].data.date)
            if (dataUltimoLance.getTime() >= dataInicio.getTime()) {
              // O lance efetuado foi durante o pregão ativo
              dataInicio = dataUltimoLance
            }
          } else {
            // Caso contrário, pega a data de abertura do pregão do lote
          }
          dataInicio.setSeconds(dataInicio.getSeconds() + this.timerPregao + 1)
          let intervalFcn = function () {
            let timeNow
            if (ServerTime.serverTime > 0) {
              timeNow = ServerTime.timeNow()
            } else {
              timeNow = new Date().getTime()
            }
            let dataFim = timeNow
            let distance = dataInicio.getTime() - dataFim
            let seconds = Math.floor(distance / 1000)

            /* if( seconds < 2){
             that.lote.status = Status.STATUS_HOMOLOGANDO
             } */
            if (distance < 1) {
              window.clearInterval(that.$intervalCronometro)
              that.countDownTimer = 0
            } else {
              that.countDownTimer = seconds
            }
          }
          intervalFcn()
          this.$intervalCronometro = window.setInterval(intervalFcn, 1000)
        }
      })
    },
    updateLancePrincipal: function () { // TODO: Retirar isto. O principal sempre deve ser o último lance.
      // this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null
      // console.log(this.lote.lancePrincipal)
    },
    remoteNovoLance: function (lote, lance) {
      this.hasNovoLance = true
      this.$nextTick(function () {
        window.setTimeout(() => {
          this.hasNovoLance = false
        }, 100)
      })

      _merge(this.lote, lote)
      // this.updateLancePrincipal()
      // this.lote.lances.unshift(lance)
      this.mountTimerCountdown()
    },
    calcPercentTimer: function (percent) {
      let downTimer = this.timerPregao
      return (downTimer * (percent / 100))
    },
    fcnTrocaFotos: function (fotoPrincipal, fotos) {
      // let imagem1 = fotoPrincipal.match(/[^\\/]+$/)[0]
      // let url = fotoPrincipal.replace(imagem1, '')
      let animFotos = []
      // animFotos.push(fotoPrincipal)
      for (var i = 0; i < fotos.length; i++) {
        animFotos.push({active: false, image: fotos[i].url})
      }
      this.animFotos = animFotos
      console.log(animFotos)
      this.startAnimFotos()
    },
    startAnimFotos: function () {
      window.clearInterval(this._timerFotos)
      let that = this
      this.animFotosIndex = 0
      this._timerFotos = window.setInterval(function () {
        let next = that.animFotosIndex + 1
        if (typeof that.animFotos[next] !== 'undefined') {
          that.lote.imagem = that.animFotos[next].image
          that.animFotosIndex = that.animFotosIndex + 1
        } else {
          that.lote.imagem = that.animFotos[0].image
          that.animFotosIndex = 0
        }
      }, 3000)
    },
    renovarTempo: function () {
      Service.renovaTempoPregaoLote(this.$route.params.id, this.lote.id)
        .then((response) => {
          // this.$emit('renovaTempo', response.data)
        })
        .catch((response) => {
          window.responseError(response)
          console.log(response)
        })
    },
    calculaPercentualVenda (v) {
      if (!Number(v.valorVenda) && !Number(v.valorFipe)) return 0
      return this.round((Number(v.valorVenda) * 100) / Number(v.valorFipe), 2)
    },
    mudaManual (calc) {
      this.numeroLote = this.lote.numero + calc
      this.$nextTick(() => {
        this.carregaPregao()
      })
    }
  },
  components: {Relogio}
}
</script>

<template>
  <div class="h-full" :class="classLanceOnline">
    <div class="pregao-tela2 h-full" :class="{'isLoading': isLoading}">
      <main class="pag-arrematante">
        <div class="row-1 flex-betw">
          <div class="grid-left">
            <div class="line-1 flex-betw flex-c-align">
              <div class="cont-vector"></div>
              <span>
                <strong>Lote {{ lote.numero }}</strong> <strong class="m-l-md" style="font-size: 80%">{{ Number(lote.quantidadeLeiloes) + 1}}º LEILÃO</strong>
						</span>
              <form @submit.prevent="carregaPregao" class="flex-betw flex-c-align">
                <label for="numLote">Ir p/lote:</label>
                <div class="c-input">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24,0H0V24H24Z" fill="none"/><path d="M7.99,14h.79l.28-.27a6.51,6.51,0,1,1,.7.7l-.27.28v.79l-5,4.99L3,19Zm6,0a4.5,4.5,0,1,0-4.5-4.5A4.494,4.494,0,0,0,13.99,14Z" transform="translate(0.51)" fill="#fff"/></svg>
                  <input id="numLote" @keydown.enter="carregaPregao" v-model="numeroLote">
                </div>
                <button @click="carregaPregao" type="submit">Ir</button>
                <button style="width: 30px; margin-left: 10px; margin-right: 5px" type="button" @click="mudaManual(-1)"><</button>
                <button style="width: 30px" type="button" @click="mudaManual(+1)">></button>
              </form>
            </div><!---->

            <div class="line-2 show-info flex-betw flex-c-align">
              <div class="item-show flex-betw flex-c-align">
                <span>Lance atual</span>
                <strong :class="{novoLance: hasNovoLance}">{{ valor | moeda }}</strong>
              </div><!---->

              <div class="item-show flex-betw flex-c-align">
                <span>Avaliação</span>
                <strong class="red-show">{{ lote.valorAvaliacao | moeda }}</strong>
              </div><!---->

              <div class="item-show flex-betw flex-c-align">
                <span>Mínimo</span>
                <strong>{{ lote.valorMinimo | moeda }}</strong>
              </div><!---->
            </div><!---->

            <div class="line-3 show-info flex-betw flex-c-align">
              <div class="item-show flex-betw flex-c-align">
                <span>Fipe/Lance</span>
                <strong>{{ fipeLance }}</strong>
              </div><!---->

              <div class="item-show flex-betw flex-c-align">
                <span>Fipe/Avaliação</span>
                <strong>{{ porcentagemAvaliacao }}%</strong>
              </div><!---->

              <div class="item-show flex-betw flex-c-align">
                <span>Fipe/Minímo</span>
                <strong>{{ porcentagemMinimo }}%</strong>
              </div><!---->
            </div><!---->

            <div class="line-4 show-info flex-betw flex-c-align">
              <div class="item-show flex-betw flex-c-align">
                <span>Tabela Fipe</span>
                <strong>{{ lote.valorTabelaFipe | moeda }}</strong>
              </div><!---->

              <div class="item-show flex-betw flex-c-align">
                <span>Total do Leilão</span>
                <strong class="red-show">{{ stats.previsaoVendas | moeda }}</strong>
              </div><!---->

              <div class="item-show item-reset flex-betw flex-c-align"></div><!---->
            </div><!---->
          </div>

          <div class="grid-right flex-betw">
            <div class="line-extra">
              <span><relogio></relogio></span>
              <div class="cont-comitente">
                <img :src="lote.comitente.imagemUrl">
              </div>
            </div>

            <div class="line-infos">
              <div class="line-1">
                <div class="cont-vector"></div>
                <h1>{{ tituloLote }}</h1>
              </div><!---->

              <div class="line-2">
                <p>Observação: <strong>{{ observacaoLote }}</strong></p>
              </div><!---->

              <div class="line-3">
                <img ref="loteImagem" :src="lote.imagem">
              </div><!---->

              <div class="line-4">
                <p>{{ descricaoLote }}</p>
              </div><!---->
            </div>
          </div>
        </div><!-- END 1 -->

        <div class="row-2">
          <ul class="list-thubs is-five-mobile">
            <li v-for="foto in animFotos">
              <a>
                <img :src="foto.image">
              </a>
            </li>

          </ul>
        </div><!-- END 2 -->
      </main>
    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?4d74f589